module.exports = __webpack_public_path__ + "static/how_you_rank.25c405e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/index/assets/how_you_rank.jpg
// module id = 369
// module chunks = 35783957827783